import type {
  IUserMasteredInfoData,
  IUserRankInfoData,
  IUserScore,
  IUserScoreData,
  IUserStats
} from '@/entities/leaderboard/types';

export * from './types';

export class UserScore implements IUserScore {
  // private _imageUrl?: string;
  // get imageUrl(): string | undefined {
  //   return this._imageUrl;
  // }
  //
  // set imageUrl(value: string) {
  //   this._imageUrl = value.replace(/\/\//g, '/');
  // }

  id: string = '';
  name: string = '';
  points: number = 0;
  rank: string = '';
  imageUrl?: string;

  constructor(data: IUserScoreData) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.points = data.points;
      this.rank = data.rank;
    }
  }
}

type RankLevel = {
  min: number;
  max: number;
  name: 'Beginner' | 'Bronze' | 'Silver' | 'Gold' | 'Platinum';
};

export const rankLevels: RankLevel[] = [
  { min: 0, max: 2000, name: 'Beginner' },
  { min: 2001, max: 4000, name: 'Bronze' },
  { min: 4001, max: 6000, name: 'Silver' },
  { min: 6001, max: 8000, name: 'Gold' },
  { min: 8001, max: 8001, name: 'Platinum' }
];

export class UserStats implements IUserStats {
  points: number = 0;
  rank: string = '';
  pointsToNextLevel: number = 0;
  learnerId: string = '';
  learnerName: string = '';
  lastCompleted: string = '';
  topInWorld: number = 0;
  rankInRegion?: IUserRankInfoData;
  rankInCountry?: IUserRankInfoData;
  rankInAccount?: IUserRankInfoData;
  rankInAccountType?: IUserRankInfoData;
  masteredTotal?: IUserMasteredInfoData;

  constructor(data: IUserStats) {
    if (data) {
      this.points = data.points;
      this.rank = data.rank;
      this.pointsToNextLevel = data.pointsToNextLevel;
      this.learnerId = data.learnerId;
      this.learnerName = data.learnerName;
      this.lastCompleted = data.lastCompleted;
      this.topInWorld = data.topInWorld;
      this.rankInRegion = data.rankInRegion;
      this.rankInCountry = data.rankInCountry;
      this.rankInAccount = data.rankInAccount;
      this.rankInAccountType = data.rankInAccountType;
    }
  }

  get progress() {
    return this.points / (this.points + this.pointsToNextLevel);
  }

  get myRank() {
    if (this.rank) {
      return this.rank.toLowerCase();
    }
  }

  get isMaxLevel() {
    return this.rank == 'Platinum';
  }

  get nextRankLevel() {
    let i = 0;
    while (rankLevels.length > i) {
      if (rankLevels[i].name == this.rank) {
        if (rankLevels[i + 1] !== undefined) {
          return rankLevels[i + 1].name.toLowerCase();
        } else {
          return 'Max';
        }
      }
      i += 1;
    }
  }
}
